import Default from './default';

class Standard extends Default {
	namespace = 'standard';
	constructor() {
		super();
	}

	beforeLeave = data => {
		super.beforeLeave(data);
	};

	afterLeave = (data) => {
		super.afterLeave(data);
	}

	beforeEnter = data => {
		super.beforeEnter(data);
	};

	afterEnter = (data) => {
		super.afterEnter(data);
	}
}

export default new Standard();
